/* LiftWrap 2.0: small helpers. Kaching keeps control of add-to-cart; nothing here adds items itself. */
(function(){
  function onReady(fn){if(document.readyState!=='loading')fn();else document.addEventListener('DOMContentLoaded',fn);}
  function info(){return document.querySelector('product-info, .product__info-container');}
  function markKaching(){
    var w=document.querySelector('.lw-kaching-slot kaching-bundles-block, kaching-bundles-block');
    var i=info(); if(!w||!i)return null;
    document.documentElement.classList.add('lw-has-kaching'); return w;
  }
  function syncSticky(w){
    var p=document.querySelector('.sticky-atc__price'); if(!p||!w||typeof w.pricing!=='function')return;
    try{var pr=w.pricing(); if(pr&&pr.discountedPrice&&pr.discountedPrice.formatted){p.innerHTML='<span class="price-item">'+pr.discountedPrice.formatted+'</span>';}}catch(e){}
  }
  function wire(w){
    if(!w||w.__lwWired)return; w.__lwWired=true;
    w.addEventListener('items-changed',function(){syncSticky(w);});
    setTimeout(function(){syncSticky(w);},300);
  }
  document.addEventListener('kaching-bundles-block-loaded',function(e){var w=(e.detail&&e.detail.component)||markKaching();markKaching();wire(w);});
  onReady(function(){
    var tries=0,t=setInterval(function(){var w=markKaching();if(w){wire(w);clearInterval(t);}if(++tries>40)clearInterval(t);},250);
    /* Sticky ATC: route through the main product-form button so Kaching's own add-to-cart handling runs. */
    document.addEventListener('click',function(ev){
      var b=ev.target.closest&&ev.target.closest('.sticky-atc button[type="submit"]'); if(!b)return;
      var main=document.querySelector('product-form .product-form__submit'); if(!main||main===b)return;
      ev.preventDefault(); main.click();
    },true);
  });
})();
